
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="incidentTabsForm">
      <div class="">
        <h3 class="form_name">Incident Tabs</h3>
  
  
          <div class="input">
            <label for="">Incident Tabs</label>
            <input type="text" class="default_input reference-form" formControlName="TabName" />
           
          </div>
         <div class="input">
            <label for="">Incident Description</label>
            <input type="text" class="default_input reference-form" formControlName="TabDescription" />
                    
          </div>
          <div class="input">
            <label for="">Incident Instruction</label>
            <input type="text" class="default_input reference-form" formControlName="TabInstructions" />
                    
          </div>
          
        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null" 
            (click)="addNew(incidentTabsForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null" 
            (click)="addNew(incidentTabsForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Incident Tabs"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(incidentTabss | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectIncidentTab(option.id)"
                  *ngFor="let option of result"
                  [value]="option.TabName"
                >
                  {{ option.TabName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Tab Name</span>
          <span class="item">Tab Description</span>
          <span class="item">Tab Instructions</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let incidentTab of incidentTabsFormArray.get('IncidentTabss')['controls']; index as i"
        (click)="onEdit(i, incidentTab.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{incidentTab.value.TabName}}</span>
           <span class="content">{{incidentTab.value.TabDescription}}</span>
           <span class="content">{{incidentTab.value.TabInstructions}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteIncidentTabs(i, incidentTab.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(incidentTabsFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  